<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/shadcn-lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();
</script>

<template>
  <h3 data-slot="accordion-header" :class="cn('flex', props.class)">
    <slot />
  </h3>
</template>
